(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["governed-bundle-experiment-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-governed-bundle-experiment]').forEach((root)=>{root.querySelectorAll('[data-thumb]').forEach((button)=>{button.addEventListener('click',()=>{const index=button.dataset.thumb;root.querySelectorAll('[data-thumb]').forEach((item)=>item.classList.toggle('is-active',item===button));root.querySelectorAll('[data-slide]').forEach((slide)=>slide.classList.toggle('is-active',slide.dataset.slide===index));});});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-pack-campaign"] && !Shopify.designMode) return;
  try {
    
function initProjectCampaign(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const end=Date.parse(root.dataset.end),clock=root.querySelector('[data-pp-countdown]');
 function tick(){const left=end-Date.now();if(!Number.isFinite(end)||left<=0){clock.textContent=root.dataset.expired;root.classList.add('pp-ended');const submit=root.querySelector('.pp-submit');if(submit)submit.disabled=true;return;}const seconds=Math.floor(left/1000);clock.textContent=Math.floor(seconds/86400)+'d  '+String(Math.floor(seconds%86400/3600)).padStart(2,'0')+'h  '+String(Math.floor(seconds%3600/60)).padStart(2,'0')+'m';}
 tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 const dialog=root.querySelector('dialog'),trigger=root.querySelector('.pp-popup-trigger');
 if(trigger)trigger.addEventListener('click',()=>dialog.showModal());
 dialog.querySelector('.pp-dialog-close').addEventListener('click',()=>dialog.close());
 dialog.querySelector('.pp-dialog-link').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
 root.querySelectorAll('.pp-card-cta').forEach(link=>link.addEventListener('click',()=>{const title=link.closest('.pp-card').querySelector('h3').textContent.trim();const select=root.querySelector('.pp-quote select');if(select)select.value=title;}));
}
document.querySelectorAll('[data-project-campaign]').forEach(initProjectCampaign);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-project-campaign]').forEach(initProjectCampaign));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-pack-teaser"] && !Shopify.designMode) return;
  try {
    
function initProjectTeaserTimer(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const end=Date.parse(root.dataset.end),clock=root.querySelector('[data-pp-teaser-clock]');
 function tick(){const remaining=end-Date.now();if(!Number.isFinite(end)||remaining<=0){clock.textContent=root.dataset.expired;return;}const seconds=Math.floor(remaining/1000);clock.textContent=Math.floor(seconds/86400)+'d  '+String(Math.floor(seconds%86400/3600)).padStart(2,'0')+'h  '+String(Math.floor(seconds%3600/60)).padStart(2,'0')+'m  '+String(seconds%60).padStart(2,'0')+'s';}
 tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
}
document.querySelectorAll('[data-pp-teaser-timer]').forEach(initProjectTeaserTimer);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-pp-teaser-timer]').forEach(initProjectTeaserTimer));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-signal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seasonal-signal')) {
    class SeasonalSignal extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.closeButton = this.querySelector('[data-signal-close]');
        this.temperature = this.querySelector('[data-signal-temperature]');
        this.temperatureLabel = this.querySelector('[data-signal-temperature-label]');
        this.collapsedTemperature = this.querySelector('[data-signal-collapsed-temperature]');
        this.dial = this.querySelector('[data-signal-dial]');
        this.config = JSON.parse(this.querySelector('[data-seasonal-signal-config]').textContent);
        this.collapseAfter = Number(this.dataset.collapseAfter) || 280;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onScroll = this.handleScroll.bind(this);
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onToggle = this.handleToggle.bind(this);

        const previewDate = /^\d{4}-\d{2}-\d{2}$/.test(this.config.previewDate || '') ? this.config.previewDate : '';
        const currentDate = previewDate ? new Date(`${previewDate}T12:00:00`) : new Date();
        const stateKey = this.config.mode === 'manual' ? 'manual' : this.resolveState(currentDate);
        const state = stateKey === 'manual' ? this.config.manual : this.config.states[stateKey];

        this.applyState(stateKey, state);
        this.handleScroll();
        this.animateTemperature(stateKey, state.temperatures);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        this.details.addEventListener('toggle', this.onToggle);
        this.closeButton.addEventListener('click', () => {
          this.details.open = false;
          this.summary.focus();
        });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        this.details?.removeEventListener('toggle', this.onToggle);
        window.clearTimeout(this.temperatureTimer);
      }

      day(year, month, date) {
        return new Date(year, month, date, 12, 0, 0, 0);
      }

      addDays(date, amount) {
        const result = new Date(date);
        result.setDate(result.getDate() + amount);
        return result;
      }

      nthWeekday(year, month, weekday, occurrence) {
        const first = this.day(year, month, 1);
        const offset = (weekday - first.getDay() + 7) % 7;
        return this.day(year, month, 1 + offset + (occurrence - 1) * 7);
      }

      lastWeekday(year, month, weekday) {
        const last = this.day(year, month + 1, 0);
        const offset = (last.getDay() - weekday + 7) % 7;
        return this.day(year, month, last.getDate() - offset);
      }

      inRange(date, start, end) {
        return date >= start && date <= end;
      }

      resolveState(inputDate) {
        const date = this.day(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
        const year = date.getFullYear();
        const presidentsDay = this.nthWeekday(year, 1, 1, 3);
        const memorialDay = this.lastWeekday(year, 4, 1);
        const laborDay = this.nthWeekday(year, 8, 1, 1);
        const thanksgiving = this.nthWeekday(year, 10, 4, 4);
        const blackFriday = this.addDays(thanksgiving, 1);

        if (this.inRange(date, this.addDays(presidentsDay, -3), presidentsDay)) return 'presidents_day';
        if (this.inRange(date, this.addDays(memorialDay, -3), memorialDay)) return 'memorial_day';
        if (this.inRange(date, this.day(year, 6, 1), this.day(year, 6, 4))) return 'fourth_of_july';
        if (this.inRange(date, this.addDays(laborDay, -3), laborDay)) return 'labor_day';
        if (this.inRange(date, this.addDays(blackFriday, -4), this.addDays(blackFriday, -3))) return 'bfcm_teaser';
        if (this.inRange(date, this.addDays(blackFriday, -2), this.addDays(blackFriday, -1))) return 'bfcm_early';
        if (date.getTime() === blackFriday.getTime()) return 'black_friday';
        if (this.inRange(date, this.addDays(blackFriday, 1), this.addDays(blackFriday, 2))) return 'bfcm_weekend';
        if (date.getTime() === this.addDays(blackFriday, 3).getTime()) return 'cyber_monday';
        if (date.getTime() === this.addDays(blackFriday, 4).getTime()) return 'bfcm_final';
        if (date.getTime() === this.addDays(blackFriday, 5).getTime()) return 'bfcm_post';

        if (this.inRange(date, this.day(year, 1, 7), this.day(year, 1, 14))) return 'valentines';
        if (this.inRange(date, this.day(year, 2, 10), this.day(year, 2, 17))) return 'st_patricks';
        if (this.inRange(date, this.day(year, 9, 20), this.day(year, 9, 31))) return 'halloween';
        if (this.inRange(date, this.day(year, 11, 1), this.day(year, 11, 25))) return 'holiday';

        const month = date.getMonth();
        if (month >= 2 && month <= 4) return 'spring';
        if (month >= 5 && month <= 7) return 'summer';
        if (month >= 8 && month <= 10) return 'fall';
        return 'winter';
      }

      applyState(stateKey, state) {
        this.dataset.state = stateKey;
        this.dataset.tone = state.tone;
        this.querySelector('[data-signal-icon]').textContent = state.icon;
        this.querySelector('[data-signal-label]').textContent = state.label;
        this.querySelector('[data-signal-heading]').textContent = state.heading;
        this.querySelector('[data-signal-message]').textContent = state.message;
        this.querySelector('[data-signal-panel-label]').textContent = state.label;
        this.querySelector('[data-signal-panel-heading]').textContent = state.heading;
        this.querySelector('[data-signal-panel-message]').textContent = state.message;
        const temperatures = state.temperatures.map((value) => value.trim()).filter(Boolean);
        const readableTemperature = temperatures.join(' → ');
        this.temperature.textContent = readableTemperature;
        this.temperatureLabel.textContent = readableTemperature;
        this.collapsedTemperature.textContent = temperatures.at(-1) || '';
        this.summary.setAttribute('aria-label', this.config.openLabel.replace('__CAMPAIGN__', state.heading));
      }

      animateTemperature(stateKey, values) {
        const temperatures = values.map((value) => value.trim()).filter(Boolean);
        if (!temperatures.length) return;
        const storageKey = `seasonal-signal:${stateKey}`;
        let hasPlayed = false;
        try {
          hasPlayed = sessionStorage.getItem(storageKey) === 'played';
        } catch (error) {
          hasPlayed = false;
        }
        if (this.reducedMotion || hasPlayed || temperatures.length === 1) {
          this.temperature.textContent = temperatures.at(-1);
          this.dial.style.strokeDashoffset = '0';
          return;
        }
        let index = 0;
        const step = () => {
          this.temperature.textContent = temperatures[index];
          this.dial.style.strokeDashoffset = String(126 - (126 * (index + 1)) / temperatures.length);
          this.classList.remove('is-animating');
          void this.offsetWidth;
          this.classList.add('is-animating');
          index += 1;
          if (index < temperatures.length) {
            this.temperatureTimer = window.setTimeout(step, 520);
          } else {
            this.classList.remove('is-animating');
            try {
              sessionStorage.setItem(storageKey, 'played');
            } catch (error) {
              return;
            }
          }
        };
        step();
      }

      handleScroll() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.classList.toggle('is-collapsed', window.scrollY > this.collapseAfter);
          this.scrollFrame = null;
        });
      }

      handleDocumentClick(event) {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.summary.focus();
        }
      }

      handleToggle() {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
      }
    }

    customElements.define('seasonal-signal', SeasonalSignal);
  }

  } catch(e) { console.error(e); }
})();
})();
